import { getUserLocale } from '@/lib/locale'

/**
 * Invoice-local money formatting. Unlike lib/locale.formatCurrency (which
 * always uses the user's locale currency), invoices carry their own
 * currency per-row so payments in USD/EUR/GBP all render correctly on the
 * same list. Locale (number separators, sign placement) still tracks the
 * tenant's Regional Settings.
 */
export function formatInvoiceMoney(amount: number | string, currency?: string | null): string {
  const n = Number(amount || 0)
  const cfg = getUserLocale()
  const cur = (currency || cfg.currency).toUpperCase().slice(0, 3)
  try {
    return new Intl.NumberFormat(cfg.locale, {
      style: 'currency',
      currency: cur,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(n)
  } catch {
    return `${cur} ${n.toFixed(2)}`
  }
}

import { tokenManager } from '@/lib/tokenManager'

/** Trigger a browser download of an invoice PDF via the server endpoint. */
export async function downloadInvoicePdf(id: number, invoiceNumber: string): Promise<void> {
  const token = tokenManager.get()
  const res = await fetch(`/api/invoicing/invoices/${id}/pdf?download=1`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  })
  if (!res.ok) throw new Error(`Failed to download PDF (${res.status})`)
  const blob = await res.blob()
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `Invoice-${invoiceNumber}.pdf`
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
